import { MdEdit, MdDelete } from "react-icons/md";
import Radiostation from "../../assets/radioStation.png";

const AdCard = () => {
  return (
    <div className="pre-cart-card">
      <div className="pre-cart-content">
        <div className="pre-cart-left">
          <div className="pre-cart-image-container">

          <img src={Radiostation} alt="product" className="pre-cart-image" />
          </div>
          <div className="pre-cart-details">
            <div className="pre-cart-info">
              <h1 className="pre-cart-title">Classic FM</h1>
              <p className="pre-cart-detail">Ad: Jingle</p>
              <p className="pre-cart-detail">Date: Jan 24 - Jan 31</p>
              <p className="pre-cart-detail">Slot: 15</p>
            </div>

            <div className="pre-cart-actions">
              <button className="pre-cart-button pre-cart-edit">
                <MdEdit />
                <span>Edit</span>
              </button>
              <button className="pre-cart-button pre-cart-remove">
                <MdDelete />
                <span>Remove</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="pre-cart-price">₦56,700</div>
    </div>
  );
};

export default AdCard;
